import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/fontawesome-free-solid";

import { ROUTES, insertIdtoUrl } from "constants/Routes.js";
import "assets/scss/customRadio.css";
import { userFormValidator, inputFocusHandler } from "utils/userFormValidate";
import BusinessUserInvitationApi from "../../../../../apis/BusinessUserInvitation";
import BusinessUserForm from "../BusinessUserForm";
import Loading from "utils/Loading";
import {
  setUserInvitation,
  getUserInvitation,
  getToken
} from "../../../../../constants/localStorageManager";
import logo from "assets/logo/soono_FF-02.png";

class BusinessUserInvitation extends Component {
  constructor() {
    super();
    this.state = {
      user_invitation: {
        email: "",
        role: ""
      },
      redirect: false,
      business_id: "",
      linkExpiredMessage: ""
    };
    this.validateUserInvitation = this.validateUserInvitation.bind(this);
  }

  componentWillMount() {
    this.validateUserInvitation();
  }

  validateUserInvitation() {
    const userInvitationId = this.props.match.params.id;
    BusinessUserInvitationApi.validate(userInvitationId)
      .then(data => {
        const user_invitation = data.data;

        if (typeof user_invitation === "string") {
          this.setState({ linkExpiredMessage: user_invitation });
        } else {
          this.setState({
            redirect: true,
            business_id: user_invitation.business.id,
            user_invitation: {
              email: user_invitation.email,
              role: user_invitation.role,
              businessName: user_invitation.business.name
            }
          });
        }
      })
      .catch(e => {
        console.log(e);
        this.setState({ linkExpiredMessage: e.response.status });
      });
  }

  render() {
    const { redirect, linkExpiredMessage } = this.state;
    const businessId = this.state.business_id;

    if (this.state.linkExpiredMessage !== "") {
      return (
        <div className="d-flex justify-content-center">
          <div className="col-md-4 offset-md-4 m-5 pb-3 border">
            <div
              className="row d-flex justify-content-center py-3"
              style={{ backgroundColor: "#29508b" }}
            >
              <img src={logo} className="logo" />
              <p className="text-center d-block text-white mt-3" />
            </div>
            <div className="mt-3 text-center text-danger">
              <div className="mb-3">
                <FontAwesomeIcon icon="exclamation-triangle" size="3x" />
              </div>
              The link has expired. Please ask to invite again or use new url.
            </div>
          </div>
        </div>
      );
    }

    if (redirect) {
      setUserInvitation(this.state.user_invitation);
      return <Redirect exact to={insertIdtoUrl(ROUTES.USER_NEW, businessId)} />;
    } else {
      return <Loading />;
    }
  }
}

export default BusinessUserInvitation;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/business-users/invitation/BusinessUserInvitation.js